module.exports = __webpack_public_path__ + "static/media/adn.20928b48.svg";